<header class="sticky-top">

  <div
    class="nav-top container-md d-flex flex-wrap align-items-center justify-content-center justify-content-md-between pt-3 pb-3">

    <nav class="navbar navbar-expand-lg navbar-light p-0">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#headerNavbar"
        aria-controls="headerNavbar" aria-expanded="false" aria-label="Toggle navigation"
        (click)="isMenuCollapsed = !isMenuCollapsed">
        <span class="navbar-toggler-icon"></span>
      </button>
    </nav>
    <a
      [routerLink]="['/', languageService.userSelectedLanguage.code, 'home']"
      class="col-4 col-md-2 text-dark text-decoration-none logo-home"
    >
      <img src="/assets/img/memorabid-logo-black.svg" alt="Logo">
    </a>

    <div class="col-md-3 text-end ms-auto icon--mobile">
      <button type="button" class="iconButton button-with-badge"
      *ngIf="messageService.userDataCount.unpaidItems"
      (click)="onIconPressed('account/cart')">
        <i class="pi pi-shopping-cart"></i>
        <span class="badge" [class.badge-two-digits]="messageService.userDataCount.unpaidItems > 9">
          {{ messageService.userDataCount.unpaidItems }}
        </span>
      </button>
      <button type="button" class="iconButton" (click)="onIconPressed('account/my-auctions/favourites')">
        <fa-icon [icon]="faHeart" size="lg"></fa-icon>
      </button>
      <button type="button" class="iconButton button-with-badge" (click)="onIconPressed('account/notifications')">
        <fa-icon [icon]="faBell" size="lg"></fa-icon>
        <span class="badge" [class.badge-two-digits]="notificationService.unreadNotificationsCount > 9"
          *ngIf="notificationService.unreadNotificationsCount > 0 && notificationService.unreadNotificationsCount < 100">
          {{ notificationService.unreadNotificationsCount }}
        </span>
        <span class="badge badge-three-digits" *ngIf="notificationService.unreadNotificationsCount >= 100">99+</span>
      </button>
      <button type="button" class="iconButton button-with-badge" (click)="onIconPressed(authService.userLogged.idProfile == 1 ? 'admin/message/list' : 'account/messages')">
        <fa-icon [icon]="faEnvelope" size="lg"></fa-icon>
        <span class="badge" [class.badge-two-digits]="messageService.unreadMessagesCount > 9"
          *ngIf="messageService.unreadMessagesCount > 0 && messageService.unreadMessagesCount < 100">
          {{ messageService.unreadMessagesCount }}
        </span>
        <span class="badge badge-three-digits" *ngIf="messageService.unreadMessagesCount >= 100">99+</span>
      </button>
      <div ngbDropdown class="iconButton text-center" #accountMobileDropdown="ngbDropdown">
        <button id="accountDropdown" type="button" class="iconButton" (click)="onAccountPressed('account')"
          ngbDropdownToggle>
          <fa-icon [icon]="faUser" size="lg"></fa-icon>
        </button>
        <div ngbDropdownMenu aria-labelledby="filterDropdown" *ngIf="authService.userLogged.idProfile != 1"
          class="accountDropdownMobile">
          <p class="mb-0 text-nowrap accountNameDropdown"><i>{{"IDS_HI" |
              translate}}{{authService.userLogged.username}}</i></p>
          <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="onIconPressed('account')">
            {{ 'IDS_ACCOUNT' | translate }}
          </button>
          <button type="button" ngbDropdownItem class="accountDropdownLink"
            (click)="onIconPressed('account/my-auctions/awarded')">
            {{ 'IDS_AUCTIONS' | translate }}
          </button>
          <!--<button type="button" ngbDropdownItem class="accountDropdownLink" (click)="onIconPressed('account/messages')">
            {{ 'IDS_MESSAGES' | translate }}
          </button>-->
          <hr>
          <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="logout()">
            {{ 'IDS_LOGOUT' | translate }}
          </button>
        </div>
        <div ngbDropdownMenu aria-labelledby="filterDropdown" *ngIf="authService.userLogged.idProfile == 1"
          class="accountDropdownMobile">
          <p class="mb-0 text-nowrap accountNameDropdown"><i>{{"IDS_HI" |
              translate}}{{authService.userLogged.username}}</i></p>
          <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="onIconPressed('account')">
            {{ 'IDS_ADMIN' | translate }}
          </button>
          <hr>
          <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="logout()">
            {{ 'IDS_LOGOUT' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="col-md-1"></div>
    <div class="col-md-6 justify-content-center search--mobile">
      <div class="d-flex align-items-center">
        <div ngbDropdown>
          <button id="filterDropdown" type="button" ngbDropdownToggle>
            {{selectedStringAuctionType | translate}}
            <fa-icon class="dropdownChevron" [icon]="faChevronDown" size="sm"></fa-icon>
          </button>
          <div ngbDropdownMenu aria-labelledby="filterDropdown">
            <p class="text-uppercase px-2 mb-0 text-nowrap memo-dropdown-header"><b>{{"IDS_MARKET" | translate}}</b></p>
            <button type="button" ngbDropdownItem class="filterDropdownLink"
              *ngFor="let type of searchService.auctionTypeList;" (click)="setAuctionType(type.key)">
              {{type.value | translate}}
            </button>
          </div>
        </div>
        <div ngbDropdown #filterDropdownButton="ngbDropdown">
          <button id="filterButton" type="button" ngbDropdownToggle>
            <fa-icon class="filter-slider" [icon]="faSlidersH"></fa-icon>
          </button>
          <div ngbDropdownMenu class="filter">
            <div class="row">
              <div class="col">
                <p class="text-uppercase px-4 mb-0 text-nowrap memo-dropdown-header"><b>{{"IDS_FILTER" | translate}}</b>
                </p>
              </div>
            </div>
            <div class="row">
              <!--<div class="col-3">
                <span class="dropdown-item filterText text-end" href="#">Sport</span>
                <span class="dropdown-item filterText text-end" href="#">{{"IDS_SEASON" | translate}}</span>
                <span class="dropdown-item filterText text-end" href="#">{{"IDS_TEAM" | translate}}</span>
                <span class="dropdown-item filterText text-end" href="#">{{"IDS_COMPETITION" | translate}}</span>
                <span class="dropdown-item filterText text-end" href="#">{{"IDS_SIGNATURE" | translate}}</span>
              </div>
              <div class="col-4">
                <button type="button" id="filter-option" class="text-start d-flex">
                  Calcio
                  <fa-icon class="dropdownChevron ms-auto" [icon]="faChevronDown" size="sm"></fa-icon>
                </button>
                <button type="button" id="filter-option" class="text-start d-flex">
                  1995/1996
                  <fa-icon class="dropdownChevron ms-auto" [icon]="faChevronDown" size="sm"></fa-icon>
                </button>
                <button type="button" id="filter-option" class="text-start d-flex">
                  Juventus FC
                  <fa-icon class="dropdownChevron ms-auto" [icon]="faChevronDown" size="sm"></fa-icon>
                </button>
                <button type="button" id="filter-option" class="text-start d-flex">
                  Tutte
                  <fa-icon class="dropdownChevron ms-auto" [icon]="faChevronDown" size="sm"></fa-icon>
                </button>
                <button type="button" id="filter-option" class="text-start d-flex">
                  Sì
                  <fa-icon class="dropdownChevron ms-auto" [icon]="faChevronDown" size="sm"></fa-icon>
                </button>
              </div>-->
              <div class="col-8">
                <span class="dropdown-item filterText text-end">{{"IDS_MATCHWORN" | translate}}</span>
                <span class="dropdown-item filterText text-end">{{"IDS_STORE" | translate}}</span>
                <span class="dropdown-item filterText text-end">{{"IDS_SIGNATURE" | translate}}</span>
                <span class="dropdown-item filterText text-end">{{"IDS_NEW" | translate}}</span>
                <span class="dropdown-item filterText text-end">{{"IDS_EXPIRING" | translate}}</span>
                <span class="dropdown-item filterText text-end">{{"IDS_ARRIVING" | translate}}</span>
              </div>
              <div class="col-4">
                <label class="label-container">
                  <input class="input-checkbox" type="checkbox" name="worn" [(ngModel)]="detailWorn">
                  <span class="checkmark"></span>
                </label>
                <label class="label-container">
                  <input class="input-checkbox" type="checkbox" name="store" [(ngModel)]="detailStore">
                  <span class="checkmark"></span>
                </label>
                <label class="label-container">
                  <input class="input-checkbox" type="checkbox" name="signature" [(ngModel)]="onlySigned">
                  <span class="checkmark"></span>
                </label>
                <label class="label-container">
                  <input class="input-checkbox" type="checkbox" name="new" [(ngModel)]="onlyNew">
                  <span class="checkmark"></span>
                </label>
                <label class="label-container">
                  <input class="input-checkbox" type="checkbox" name="expiring" [(ngModel)]="onlyExpiring">
                  <span class="checkmark"></span>
                </label>
                <label class="label-container">
                  <input class="input-checkbox" type="checkbox" name="arriving" [(ngModel)]="onlyArriving">
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="row">
                <div class="col">
                  <button type="button" class="mt-1 text-uppercase confirm-filter"
                    (click)="filterDropdownButton.close();search();">{{"IDS_CONFIRMATION" | translate}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <input #searchInputHeader id="searchInputHeader" type="search" [(ngModel)]="searchText"
          [placeholder]="'IDS_GLOBAL_SEARCH' | translate" aria-label="Search" (keydown.enter)="search()">
        <button id="searchButton" type="button" (click)="search()">
          <fa-icon [icon]="faSearch"></fa-icon>
        </button>
      </div>
    </div>
    <div class="col-md-3 text-end icon--desktop">
      <button type="button" class="iconButton button-with-badge"
      *ngIf="messageService.userDataCount.unpaidItems"
      (click)="onIconPressed('account/cart')">
        <i class="pi pi-shopping-cart"></i>
        <span class="badge" [class.badge-two-digits]="messageService.userDataCount.unpaidItems > 9">
          {{ messageService.userDataCount.unpaidItems }}
        </span>
      </button>
      <button type="button" class="iconButton" (click)="onIconPressed('account/my-auctions/favourites')">
        <fa-icon [icon]="faHeart" size="lg"></fa-icon>
      </button>
      <button type="button" class="iconButton button-with-badge" (click)="onIconPressed('account/notifications')">
        <fa-icon [icon]="faBell" size="lg"></fa-icon>
        <span class="badge" [class.badge-two-digits]="notificationService.unreadNotificationsCount > 9"
          *ngIf="notificationService.unreadNotificationsCount > 0 && notificationService.unreadNotificationsCount < 100">
          {{ notificationService.unreadNotificationsCount }}
        </span>
        <span class="badge badge-three-digits" *ngIf="notificationService.unreadNotificationsCount >= 100">99+</span>
      </button>
      <button type="button" class="iconButton button-with-badge" (click)="onIconPressed(authService.userLogged.idProfile == 1 ? 'admin/message/list' : 'account/messages')">
        <fa-icon [icon]="faEnvelope" size="lg"></fa-icon>
        <span class="badge" [class.badge-two-digits]="messageService.unreadMessagesCount > 9"
          *ngIf="messageService.unreadMessagesCount > 0 && messageService.unreadMessagesCount < 100">
          {{ messageService.unreadMessagesCount }}
        </span>
        <span class="badge badge-three-digits" *ngIf="messageService.unreadMessagesCount >= 100">99+</span>
      </button>
      <div ngbDropdown class="iconButton text-center" #accountDropdown="ngbDropdown">
        <button id="accountDropdown" type="button" class="iconButton" (click)="onAccountPressed('account')"
          ngbDropdownToggle>
          <fa-icon [icon]="faUser" size="lg"></fa-icon>
        </button>
        <div ngbDropdownMenu aria-labelledby="filterDropdown" *ngIf="authService.userLogged.idProfile != 1"
          class="accountDropdown">
          <p class="mb-0 text-nowrap accountNameDropdown"><i>{{"IDS_HI" |
              translate}}{{authService.userLogged.username}}</i></p>
          <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="onIconPressed('account')">
            {{ 'IDS_ACCOUNT' | translate }}
          </button>
          <button type="button" ngbDropdownItem class="accountDropdownLink"
            (click)="onIconPressed('account/my-auctions/awarded')">
            {{ 'IDS_AUCTIONS' | translate }}
          </button>
          <!--<button type="button" ngbDropdownItem class="accountDropdownLink" (click)="onIconPressed('account/messages')">
            {{ 'IDS_MESSAGES' | translate }}
          </button>-->
          <hr>
          <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="logout()">
            {{ 'IDS_LOGOUT' | translate }}
          </button>
        </div>
        <div ngbDropdownMenu aria-labelledby="filterDropdown" *ngIf="authService.userLogged.idProfile == 1"
          class="accountDropdown">
          <p class="mb-0 text-nowrap accountNameDropdown"><i>{{"IDS_HI" |
              translate}}{{authService.userLogged.username}}</i></p>
          <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="onIconPressed('account')">
            {{ 'IDS_ADMIN' | translate }}
          </button>
          <hr>
          <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="logout()">
            {{ 'IDS_LOGOUT' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <nav class="navbar navbar-expand-lg navbar-light p-0">
    <div class="container-md">
      <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse align-items-stretch" id="headerNavbar">
        <ul class="navbar-nav me-auto">
          <li class="nav-item one-line-item" routerLinkActive="active-link">
            <a class="nav-link text-uppercase" routerLink="{{'/'+languageService.userSelectedLanguage.code + '/search-result-all'}}" (click)="searchAllAuction()"
              (click)="isMenuCollapsed = true">{{"IDS_ASTE" | translate}}</a>
          </li>
          <li class="nav-item" routerLinkActive="active-link">
            <a class="nav-link text-uppercase" routerLink="{{'/'+languageService.userSelectedLanguage.code + '/search-result-worn'}}" (click)="searchMatchWorn()"
              (click)="isMenuCollapsed = true"><span class="memorabilia">Memorabilia</span><br>{{"IDS_MATCHWORN" |
              translate}}</a>
          </li>
          <li class="nav-item" routerLinkActive="active-link">
            <a class="nav-link text-uppercase" routerLink="{{'/'+languageService.userSelectedLanguage.code + '/search-result-store'}}" (click)="searchStore()"
              (click)="isMenuCollapsed = true"><span class="memorabilia">Memorabilia</span><br>{{"IDS_STORE" |
              translate}}</a>
          </li>
          <li class="nav-item" routerLinkActive="active-link">
            <a class="nav-link text-uppercase" routerLink="{{'/'+languageService.userSelectedLanguage.code + '/search-result-signed'}}" (click)="searchSigned()"
              (click)="isMenuCollapsed = true"><span class="memorabilia">Memorabilia</span><br>{{"IDS_AUTOGRAPHED" |
              translate}}</a>
          </li>
        </ul>
        <ul class="navbar-nav ms-auto">
          <li class="item-right-navbar" routerLinkActive="active-link">
            <a class="nav-link text-uppercase" routerLink="{{'/'+languageService.userSelectedLanguage.code + '/about-us'}}"
              (click)="isMenuCollapsed = true">{{"IDS_WHO_WE_ARE" | translate}}</a>
          </li>
          <li class="item-right-navbar" routerLinkActive="active-link">
            <a class="nav-link text-uppercase" routerLink="{{'/'+languageService.userSelectedLanguage.code + '/how-works-memorabid'}}"
              (click)="isMenuCollapsed = true">{{"IDS_HOW_WORK" | translate}}</a>
          </li>
          <li class="item-right-navbar" routerLinkActive="active-link">
            <a class="nav-link text-uppercase become-seller-link" routerLink="{{'/'+languageService.userSelectedLanguage.code + '/become-seller'}}"
              (click)="isMenuCollapsed = true">{{"IDS_BECOME_SELLER" | translate}}</a>
          </li>
        </ul>
        <div ngbDropdown class="ms-1 align-self-center">
          <button id="languageDropdown" type="button" ngbDropdownToggle>
            <img class="flagImg" [src]="imgCountry" alt="flag">
          </button>
          <div ngbDropdownMenu aria-labelledby="languageDropdown" class="dropdown-menu-lg-end">
            <button *ngFor="let lang of languageService.AppLanguageList" (click)="changeLanguages(lang)" type="button"
              ngbDropdownItem class="lang-dropdown justify-content-center align-items-center d-flex">
              <p class="pt-3">{{ lang.description }}</p>
              &nbsp;&nbsp;
              <img class="flagImg" src="/assets/img/{{lang.code}}.png" alt="flag">
            </button>
          </div>
        </div>
      </div>

    </div>
  </nav>
</header>
